<template>
  <div class="home">
    <div id="drag">
      <div class="Yuan" @click="testShowBtn">
        <span></span>
        <span></span>
      </div>
      <div class="Yuan-title">
        <div
          style="height: 20px; width: 100%; cursor: all-scroll"
          class="YuanTitleDrag"
        ></div>
        <div class="zTreeDiv">
          <ul id="discussTheTopicTree" class="ztree"></ul>
        </div>
      </div>
    </div>

    <div id="MyViewerDiv"></div>

    <canvas id="snapshot" style="display: none"></canvas>

    <!-- <button onclick="snaphot();" style="position:absolute;"></button> -->
    <!-- @*视点选择框*@ -->
    <div id="lll">
      <div
        id="div_viewpoint"
        class="m-right-sidebar"
        style="
          position: absolute;
          display: none;
          top: 20px;
          right: 30px;
          transition: none;
        "
      >
        <h2 style="font-size: 20px; font-weight: 300; cursor: all-scroll">
          视点保存
        </h2>
        <div
          class="btnClose close_bt_p"
          onclick="bimViewPointNew.hiddenViewPoint();"
          style="color: #000000; font-weight: 300"
        >
          ×
        </div>
        <!-- <hr class="v-spacer-large"> -->
        <div class="navBox">
          <!-- <ul id="nav" class="nav" name="nav" style="display: block;">
            <li>
              <b style="border-radius: 15px 0 0 15px;">基本</b>
            </li>
            <li>
              <b>碰撞</b>
            </li>
            <li>
              <b>协作</b>
            </li>
          </ul>-->
          <div id="search_viewpoint" class="search">
            <b class="imgsearch"></b>
            <button
              id="vp-imgsearch"
              style="position: absolute; left: 0"
              class="btnSearch"
              onclick="bimViewPointNew.filterNodes()"
            >
              <img
                width="20px"
                style="position: relative; left: 4px"
                src="@/assets/img/搜索 (2).png"
              />
            </button>
            <input
              type="text"
              id="vp-searchtxt"
              value="请输入搜索内容..."
              onfocus="if(value=='请输入搜索内容...')  {value=''}"
              onblur="if (value=='') {value='请输入搜索内容...'}"
              onkeypress="bimViewPointNew.viewpoint_keydown(event)"
              name="name"
              style="padding-left: 20px"
            />
            <b
              class="clo1"
              id="vp-close"
              style="
                font-weight: 300;
                position: absolute;
                right: 0;
                color: #c3c3c3;
                font-size: 16px;
              "
              onclick="bimViewPointNew.closeShow()"
              >×</b
            >
          </div>
        </div>
        <div class="body_viewpoint">
          <ul id="treeDemo_viewpoint" class="treeDemo_viewpoint ztree"></ul>
        </div>
        <!-- <hr class="v-spacer-large"> -->
        <button
          class="btn btn-info viewpoint_btn btn_fas"
          style="display: none"
          id="vp-btn-deletebatch"
          data-placement="bottom"
          data-toggle="tooltip"
          title="删除"
          onclick="bimViewPointNew.deleteViewPoints()"
        >
          删除
        </button>
        <el-button
          type="primary"
          id="vp-btn-mark"
          data-placement="bottom"
          data-toggle="tooltip"
          title="涂鸦"
          size="small"
          style="margin: 0 0 0 66px; display: inline-block"
          onclick="bimViewPointNew.showMarkTool()"
          >涂鸦</el-button
        >
        <el-button
          type="primary"
          id="vp-btn-save"
          data-placement="bottom"
          data-toggle="tooltip"
          size="small"
          title="保存"
          onclick="bimViewPointNew.onSaveLayer()"
          style="display: inline-block"
          >保存</el-button
        >
        <button
          size="small"
          type="primary"
          class="btn btn-info"
          id="vp-btn-share"
          title="分享"
          style="display: none"
          data-placement="bottom"
          data-toggle="tooltip"
          onclick="shareStructureQR.viewpointQr()"
        >
          分享
        </button>
        <button
          class="btn btn-info viewpoint_btn btn_fastn"
          style="display: none"
          id="vp-btn-startclash"
          data-placement="bottom"
          data-toggle="tooltip"
          title="发起碰撞"
          onclick="workflowCollision.main('','','-1')"
        >
          发起碰撞
        </button>
        <div
          id="rMenu_viewpoint"
          class="rMenu"
          style="top: 123px; visibility: hidden"
        >
          <ul id="rShowMenu_viewpoint">
            <li
              id="vp_m_add"
              onclick="bimViewPointNew.addTreeNode()"
              style="display: list-item"
            >
              新建视点目录
            </li>
            <li
              id="vp_m_del"
              onclick="bimViewPointNew.removeTreeNode()"
              style="display: list-item"
            >
              删除
            </li>
            <li
              id="vp_m_ren"
              onclick="bimViewPointNew.renameTreeNode()"
              style="display: list-item"
            >
              重命名
            </li>
            <!-- <li
              id="vp_m_faq"
              onclick="bimViewPointNew.createFlow()"
              style="display: list-item;"
            >发起流程</li>-->
            <!-- @*
            <li
              id="vp_m_updateMark"
              onclick="bimViewPointNew.updateMark()"
              style="display: none;"
            >更新涂鸦</li>*@-->
          </ul>
        </div>
      </div>
    </div>
    <div id="box_gray" class="gray"></div>
    <!-- @*过滤器*@ -->
    <div class="filter_box" id="gg" style="cursor: default; display: none">
      <div class="box_title">过滤器</div>
      <div class="btnClose" onclick="bimOriginFilter.hideDoc()">×</div>

      <div class="box_content">
        <div class="tab_title">
          <ul id="tabs" class="clearfix">
            <li class="current" onclick="boxselect(this)">
              <a href="#" title="过滤器">过滤器</a>
            </li>
            <li onclick="boxselect(this)">
              <a href="#" title="框选集">框选集</a>
            </li>
          </ul>
        </div>
        <!-- <ul id="treeDemo" class="ztree content_particulars"></ul> -->
        <div class id="menu_content_box">
          <div id="tab1" class="menu_table" style="display: block">
            <div class="farther" id="list">
              <div class="body_origin_filter">
                <ul id="treeDemo_origin_filter" class="ztree scroll_bar"></ul>
              </div>
              <div
                id="rMenu_origin_filter"
                class="rMenu"
                style="top: 253px; left: 257px; visibility: hidden"
              >
                <ul id="rShowMenu_origin_filter">
                  <li
                    id="origin_f_add"
                    onclick="bimOriginFilter.xx()"
                    style="display: none"
                  >
                    增加
                  </li>
                  <li
                    id="origin_f_del"
                    onclick="bimOriginFilter.yy()"
                    style="display: none"
                  >
                    删除
                  </li>
                  <li
                    id="origin_f_ren"
                    onclick="bimOriginFilter.zz()"
                    style="display: none"
                  >
                    重命名
                  </li>
                </ul>
              </div>
            </div>
            <div class="footr_box">
              <div class="box_options" style="display: none">
                <div class="clearfix">
                  <input
                    class="fl"
                    type="button"
                    onclick="bimOriginFilter.contreChoose()"
                    value="反选"
                  />
                  <input
                    class="fl daochu"
                    type="button"
                    onclick="filterExecute.modelshowEXCELvalue()"
                    id="daochu_btn"
                    value="导出工程量"
                    style="display: none"
                  />
                  <input
                    class="fr top_img"
                    type="button"
                    id="advanced_btn"
                    value="高级选项"
                  />
                </div>
                <div class="sidebar_advanced" style="display: none">
                  <div class="screen_box">
                    <p>
                      <span>参数:</span>
                      <select id="canshu" class="select"></select>
                    </p>
                    <p>
                      <span>条件:</span>
                      <select id="tiaojian" class="select">
                        <option value>请选择筛选条件</option>
                      </select>
                    </p>
                    <p>
                      <span>值:</span>
                      <input value id="chooseValue" />
                    </p>
                  </div>
                </div>
              </div>

              <div class="box_btn_op">
                <div class="clearfix">
                  <!-- @*
                    <input
                      class="fl"
                      type="button"
                      value="确定"
                      onclick="filterExecute.attribute_select()"
                  />*@-->
                  <input
                    class="fr ml_20"
                    type="button"
                    onclick="bimOriginFilter.attribute_save()"
                    value="收藏"
                  />
                </div>
              </div>
            </div>
          </div>
          <div id="tab2" class="menu_table" style="display: none">
            <div class="farther" id="list">
              <div class="body_originOther_filter">
                <ul
                  id="treeDemo_originOther_filter"
                  class="ztree scroll_bar"
                ></ul>
              </div>
              <div
                id="rMenu_originOther_filter"
                class="rMenu"
                style="visibility: hidden"
              >
                <ul id="rShowMenu_originOther_filter">
                  <li
                    id="originOther_f_addPlanDir"
                    onclick="bimOriginFilter.addPlanDir()"
                  >
                    新建目录
                  </li>
                  <li
                    id="originOther_f_delPlan"
                    onclick="bimOriginFilter.removePlan()"
                  >
                    删除
                  </li>
                  <li
                    id="originOther_f_renPlan"
                    onclick="bimOriginFilter.renamePlan()"
                  >
                    重命名
                  </li>
                  <!-- <li id="originOther_f_faq" onclick="bimOriginFilter.createFlow()">发起流程</li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--添加标签 -->
    <div class="AddLable">
      <input type="hidden" id="mobl10" />
      <input type="hidden" id="mobl11" />
      <input type="hidden" id="mobl12" />
      <div>
        <label class="labelName">名称：</label>
        <input id="lableName" type="text" />
      </div>
      <br />
      <div>
        <label class="labelName">地点：</label>
        <input id="lableAddr" type="text" />
      </div>
      <br />
      <div>
        <label class="labelName">拍摄时间：</label>
        <input id="lableTime" type="text" placeholder="yyyy-MM-dd" />
      </div>
      <br />
      <div>
        <label>类型：</label>
        <dl class="labelType">
          <!-- <dd>
            <input type="radio" name="lableType" checked value="1" />
            <label for="material">
              <img src="../../assets/img/bmmc.png" /> 材料
            </label>
          </dd>
          <dd>
            <input type="radio" name="lableType" value="2" />
            <label for="material">
              <img src="../../assets/img/bmmc.png" /> 材料
            </label>
          </dd>-->
        </dl>
      </div>
      <br />
      <div class="isQJ" style="display: none">
        <label class="labelName">是否全景图：</label>
        <input type="radio" name="isQJ" value="1" />是
        <input type="radio" name="isQJ" value="0" checked />否
      </div>
      <br />
      <div class="lableFile">
        <label>文件：</label>
        <button
          type="button"
          class="layui-btn layui-btn layui-btn-sm marginLeft10"
          id="lableFile"
        >
          选择文件
        </button>
      </div>
      <br />
      <div class="qjLink" style="display: none">
        <label class="labelName">全景链接：</label>
        <input id="qjLink" type="text" />
      </div>
      <br />
      <div class="form-group rt">
        <button id="lableSubmit"></button>
        <button
          type="button"
          class="layui-btn"
          onclick="EaBIM.lableSaveChange()"
        >
          提交
        </button>
        <!-- <button type="button" class="layui-btn" id="lableSubmit">提交</button> -->
      </div>
      <br />
    </div>
    <!-- 添加参数 -->
    <div class="AddProperty">
      <p>
        <button
          type="button"
          class="layui-btn layui-btn-normal layui-btn-sm marginLeft10"
          onclick="EaBIM.addPropertyGroup()"
        >
          添加分组
        </button>
        <br />
        <br />
      </p>
    </div>
    <el-card
      class="addTopic"
      :body-style="{ padding: '10px' }"
      shadow="hover"
      v-show="modelId != -1"
    >
      <div style="display: flex; justify-content: center; align-item: center">
        <div :class="addClass" v-show="isShowaddClass">
          <el-select
            filterable
            v-model="value"
            placeholder="请选择标签"
            @change="selectChange1"
          >
            <el-option
              v-for="item in optionstype"
              :key="item.ptps01"
              :label="item.ptps03"
              :value="item.ptps01"
            ></el-option>
          </el-select>
        </div>
        <div :class="addClass" v-show="isShowaddClass">
          <el-select
            filterable
            type="warning"
            v-model="value2"
            placeholder="请选择创建人"
            @change="selectChange2"
          >
            <el-option
              v-for="item in optionstype2"
              :key="item.user01"
              :label="item.user04"
              :value="item.user01"
            ></el-option>
          </el-select>
        </div>
        <div>
          <el-button :icon="iconClass" @click="isShow2"></el-button>
        </div>
      </div>
      <div :class="addClass" v-show="isShowaddClass" style="position: relative">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="ptps04" align="center" label="标签">
            <template slot-scope="scope">
              <img
                :src="$store.state.baseUrl + scope.row.ptps04"
                alt
                width="32px"
                height="32px"
              />
            </template>
          </el-table-column>
          <el-table-column prop="pjtp04" align="center" label="名称">
            <template slot-scope="scope">
              <el-button
                size="small"
                @click="rowClick(scope.row)"
                :title="scope.row.pjtp04"
              >
                <p
                  style="
                    width: 30px;
                    display: block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                >
                  {{ scope.row.pjtp04 }}
                </p>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="user04"
            align="center"
            label="创建人"
          ></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="danger"
                @click="delectTopic(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <div id="taolun" style="display: none">
      <topic-tao :id="id"></topic-tao>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="发起话题讨论"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <el-form label-width="80px">
        <el-form-item label="标签">
          <el-select filterable v-model="value" placeholder="请选择标签">
            <el-option
              v-for="item in optionstype"
              :key="item.ptps01"
              :label="item.ptps03"
              :value="item.ptps01"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称">
          <el-input
            placeholder="请输入话题讨论名称"
            v-model="TopicName"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTopic2">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import topicTao from "./topicTaolun.vue";
import {
  GetModelListByXid,
  GetptopicsetList,
  GetTopicUserList,
  AddTopic,
  GetTopicList,
  DelTopic,
  GetWorkPlaneTree2,
  GetModelLableList,
  FindWorkPlaneModel,
} from "@/setAxios";
import interact from "interactjs";
export default {
  name: "viewModel",
  components: {
    topicTao,
  },
  data() {
    return {
      dialogVisible: false,
      TopicName: "",
      modelId: -1,
      taoTicDetatil: null,
      sssx: "as",
      isShowaddClass: true,
      isShow: false,
      testSshow: true,
      optionstype: null,
      optionstype2: null,
      query: "",
      iconClass: "el-icon-arrow-left",
      addClass: "animated fadeInLeft back",
      isShow: true,
      tableData: [],
      url: "",
      options: {},
      value: 0,
      value2: 0,
      isdblclick: true,
      indexs: 0,
      modelSelectIds: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      zIndex: null,
      id:""
    };
  },
  methods: {
    //初始化ztree
    init() {
      var _this = this;
      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: false,
        },
        data: {
          key: {
            name: "label",
          },
          simpleData: {
            enable: true,
            idKey: "ID",
            pIdKey: "ParentId",
          },
        },
        callback: {
          onClick: onclick,
        },
      };
      var objs = $.fn.zTree.init(
        $("#discussTheTopicTree"),
        setting,
        this.options
      );
      if (objs != null) {
        $("#discussTheTopicTree_1_a").click();
      }
      function onclick(event, treeId, treeNode) {
        _this.showModel(treeNode.ID);
      }
    },
    testShowBtn() {
      if ($(".Yuan-title").css("display") != "none") {
        $(".Yuan-title").css("display", "none");
      } else {
        $(".Yuan-title").css("display", "block");
      }
    },
    rowClick(row) {
      this.id = row.pjtp01;
      var jsonObject = JSON.parse(row.pjtp08.replace(/'/g, '"'));
      EaBIM.view.restoreState(jsonObject);
      if (this.zIndex) {
        layer.close(this.zIndex);
      }

      setTimeout(() => {
        this.zIndex = layer.open({
          type: 1, //此处以iframe举例
          title: row.pjtp04,
          area: ["340px", "700px"],
          shade: 0,
          maxmin: false,
          resize: false,
          offset: "r",
          content: $("#taolun").show(),
        });
      }, 500);
    },
    selectChange1(val) {
      this.value = val;
      this.aa();
    },
    selectChange2(val) {
      this.value2 = val;
      this.aa();
    },
    // 删除
    delectTopic(row) {
      let params = {
        id: row.pjtp01,
      };
      this.$confirm("是否删除该话题?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          DelTopic({ ...params }).then((res) => {
            if (res.Code > 0) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.aa();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 添加

    addTopic() {
      this.dialogVisible = true;
    },
    addTopic2() {
      var model = EaBIM.isSelect();
      if (this.value == 0) {
        this.$message({
          type: "warning",
          message: "请先选择类型",
        });
      } else if (this.TopicName == "" || this.TopicName == null) {
        this.$message.warning("请输入话题讨论名称");
      } else {
        let params = {
          pjtp02: localStorage.xid,
          pjtp03: this.value,
          pjtp04: this.TopicName,
          pjtp05: this.modelId,
          pjtp06: model.dbid,
          pjtp07: model.fragid,
          pjtp08: model.viewerstate,
          pjtp09: localStorage.id,
        };
        AddTopic(params).then((res) => {
          if (res.Code > 0) {
            this.$message({
              type: "success",
              message: "添加成功",
            });
            this.dialogVisible = false;
            this.aa();
          }
        });
      }
    },
    typeChange(data) {
      //(data);
      this.aa();
      this.pageIndex = 1;
      this.pageSize = 10;
    },
    isShow2() {
      let _this = this;
      if (this.isShow == false) {
        this.isShow = true;
        this.isShowaddClass = true;
        this.addClass = "animated fadeInLeft back";
        this.iconClass = "el-icon-arrow-left";
      } else {
        this.addClass = "animated fadeOutLeft back";
        this.iconClass = "el-icon-arrow-right";
        this.isShow = false;
        setTimeout(function () {
          _this.isShowaddClass = false;
        }, 300);
      }
    },
    viewers(data) {
      if (data.type == 1) {
        this.modelId = data.modelId;
        data.enterType = "httl";
        this.aa();
      } else {
        this.modelId = -1;
      }
      EaBIM.localServerModels(data);
    },
    getData() {
      let params = {
        xid: localStorage.getItem("xid"),
        pid: -1,
      };
      GetWorkPlaneTree2(params).then((res) => {
        this.options = res.Data;
        this.options.forEach((item) => {
          this.judge(item);
        });
        this.init();
      });
    }, // 判断类型
    judge(item) {
      if (item.wopl07 == 1) {
        return (item.iconSkin = "pIcon01");
      } else if (item.wopl07 == 2) {
        return (item.iconSkin = "pIcon02");
      } else if (item.wopl07 == 3) {
        return (item.iconSkin = "pIcon03");
      } else {
        return (item.iconSkin = "pIcon04");
      }
    },
    showModel(value, index) {
      if (value.length) {
        value = value[0];
      }
      let params = {
        id: value,
      };
      FindWorkPlaneModel(params).then((res) => {
        if (res.Data == null) {
          this.$message({
            type: "warning",
            message: "此节点未绑定模型或选择集",
          });
          return false;
        }
        let data = res.Data;
        this.viewers(data);
      });
    },
    aa() {
      var params = {
        xid: localStorage.xid,
        modelId: this.modelId,
        lableId: this.value,
        userid: this.value2,
      };
      GetTopicList(params).then((res) => {
        // 第一条讨论信息展示
        this.tableData = res.Data;
        if (this.tableData) {
          EaBIM.topicLoad(res.Data);
          // var jsonObject = JSON.parse(res.Data[0].pjtp08.replace(/'/g, '"'));
          // EaBIM.view.restoreState(jsonObject);
          // layer.closeAll();
          // layer.open({
          //   type: 1, //此处以iframe举例
          //   title: res.Data[0].pjtp04,
          //   area: ["340px", "700px"],
          //   shade: 0,
          //   maxmin: false,
          //   resize: false,
          //   offset: "r",
          //   content: $("#taolun").show(),
          // });
        }
      });

      var params = {
        xid: localStorage.getItem("xid"),
      };
      GetptopicsetList({ params }).then((res) => {
        this.optionstype = res.Data.list;
        this.optionstype.unshift({ ptps01: 0, ptps03: "分类" });
      });
      var params = {
        xid: localStorage.getItem("xid"),
        modelId: this.modelId,
      };
      GetTopicUserList({ ...params }).then((res) => {
        this.optionstype2 = res.Data;
        this.optionstype2.unshift({ user01: 0, user04: "用户" });
      });
    },
    // fenye
    handleSizeChange(val) {
      this.pageSize = val;
      this.aa();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.aa();
    },
  },
  created() {
    this.flushSession();
    this.getData();
    window.discussTopic = this;
  },
  mounted() {
    document.oncontextmenu = function () {
      return false;
    };
    Fcis.Fc(".Yuan", "#drag");
    Fcis.Fc(".lll", "#div_viewpoint");
    Fcis.Fc(".lll", "#gg");

    interact(".Yuan-title").resizable({
      edges: { top: false, left: false, bottom: true, right: true },
      listeners: {
        move: function (event) {
          let { x, y } = event.target.dataset;

          x = (parseFloat(x) || 0) + event.deltaRect.left;
          y = (parseFloat(y) || 0) + event.deltaRect.top;

          Object.assign(event.target.style, {
            width: `${event.rect.width}px`,
            height: `${event.rect.height}px`,
            transform: `translate(${x}px, ${y}px)`,
          });

          Object.assign(event.target.dataset, { x, y });
        },
      },
    });
  },
};
</script>

<style lang="less">
#drag {
  left: 90%;
  top: 15%;
}
// .adsk-viewing-viewer .adsk-toolbar{
//   left: 50%;
// }
/deep/ .view {
  padding: 0;
}
#MyViewerDiv {
  height: 100%;
  width: 100%;
  position: absolute;
  // float: left;
}
.home {
  // overflow: auto;
  // height: 100%;
  // position: relative;
}

.body_viewpoint .treeDemo_viewpoint {
  background: rgba(255, 255, 255, 0.8);
  width: 96%;
  height: 100%;
  border: none;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 15px;
}
.layer-background {
  background: rgba(255, 255, 255, 0.8) !important;
}
.addTopic {
  position: absolute;
  z-index: 10;
}
</style>
